const it = {
  contactForm: {
    firstName: {
      label: "Nome",
      error: "Inserisci il tuo nome",
    },
    lastName: {
      label: "Cognome",
      error: "Inserisci il tuo cognome",
    },
    email: {
      label: "Email",
      error: "Inserisci un'email valida",
    },
    message: {
      label: "Messaggio",
      error: "Inserisci un messaggio",
      errorTooLong: "Il messaggio è troppo lungo",
    },
    submit: "INVIA",
    successMessage:
      "Grazie per averci contattato! Ti risponderemo al più presto.",
    errorMessage: "Si è verificato un errore. Riprova più tardi.",
  },
  dropzone: {
    uploadFile: "Clicca per caricare o trascina il tuo file qui",
    fileUploaded: "File caricato: ",
  },
  funnelCompany: {
    proceed: "AVANTI",
    of: "di",
    privacy: "Acconsento al trattamento dei dati personali: ",
    errorMessage: "Si è verificato un errore. Riprova più tardi.",
    goHome: "TORNA ALLA HOME",
    validation: {
      nameRequired: "Il nome è obbligatorio",
      surnameRequired: "Il cognome è obbligatorio",
      roleRequired: "Il ruolo è obbligatorio",
      companyRequired: "Il nome dell'azienda è obbligatorio",
      emailInvalid: "Inserisci un indirizzo email valido",
      phoneInvalid: "Inserisci un numero di telefono valido",
      activityRequired: "Il campo attività è obbligatorio",
    },
  },
  funnelDev: {
    proceed: "AVANTI",
    goBack: "TORNA INDIETRO",
    of: "di",
    errorMessage: "Si è verificato un errore. Riprova più tardi.",
    goHome: "TORNA ALLA HOME",
    validation: {
      urlInvalid: "Inserisci un URL valido",
      linkedinInvalid: "Inserisci un URL valido",
      freelancerRequired: "Devi confermare disponibilità freelance",
      devPowerRequired: "Descrivi il tuo dev power",
      jobTypeRequired: "Seleziona almeno un tipo di lavoro",
      jobLengthRequired: "Seleziona almeno una durata",
      firstNameRequired: "Il nome è obbligatorio",
      lastNameRequired: "Il cognome è obbligatorio",
      emailInvalid: "Inserisci un'email valida",
      phoneInvalid: "Inserisci un numero di telefono valido",
      cvFormatInvalid: "Formato CV non supportato. Usa pdf, doc, docx, odt.",
    },
  },
} as const

const en = {
  contactForm: {
    firstName: {
      label: "First Name",
      error: "Please enter your first name",
    },
    lastName: {
      label: "Last Name",
      error: "Please enter your last name",
    },
    email: {
      label: "Email",
      error: "Please enter a valid email",
    },
    message: {
      label: "Message",
      error: "Please enter a message",
      errorTooLong: "The message is too long",
    },
    submit: "SUBMIT",
    successMessage:
      "Thank you for contacting us! We will get back to you soon.",
    errorMessage: "An error occurred. Please try again later.",
  },
  dropzone: {
    uploadFile: "Click to upload or drag and drop your file here",
    fileUploaded: "File uploaded: ",
  },
  funnelCompany: {
    proceed: "CONTINUE",
    of: "of",
    privacy: "I consent to the processing of personal data: ",
    errorMessage: "An error occurred. Please try again later.",
    goHome: "GO TO THE HOMEPAGE",
    validation: {
      nameRequired: "First name is required",
      surnameRequired: "Last name is required",
      roleRequired: "Role is required",
      companyRequired: "Company name is required",
      emailInvalid: "Please enter a valid email",
      phoneInvalid: "Please enter a valid phone number",
      activityRequired: "Activity is required",
    },
  },
  funnelDev: {
    proceed: "CONTINUE",
    of: "of",
    goBack: "GO BACK",
    errorMessage: "An error occurred. Please try again later.",
    goHome: "GO TO THE HOMEPAGE",
    validation: {
      urlInvalid: "Please enter a valid URL",
      linkedinInvalid: "Please enter a valid URL",
      freelancerRequired: "You must accept freelance availability",
      devPowerRequired: "Please describe your dev power",
      jobTypeRequired: "Please select at least one job type",
      jobLengthRequired: "Please select at least one job length",
      firstNameRequired: "First name is required",
      lastNameRequired: "Last name is required",
      emailInvalid: "Please enter a valid email",
      phoneInvalid: "Please enter a valid phone number",
      cvFormatInvalid: "Unsupported CV format. Use pdf, doc, docx, odt.",
    },
  },
} as const

export const translations = { it, en }
